module.exports = __webpack_public_path__ + "img/ypo-logo-2.e66a0dcd.png";